import {useCallback, useEffect, useRef, useState} from 'react';
import {Button, CircularProgress, Stack, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import RegistrationLayout from './RegistrationLayout';
import ResendConfirmation from './ResendConfirmation';
import {confirmEmail} from '../../services/EmailConfirmationClient';
import {normalizeApiError} from '../../common/apiErrors';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
export default function ConfirmEmailPage() {
    const {t} = useAppTranslation();
    const [parameters] = useState(() => new URLSearchParams(window.location.hash.slice(1)));
    const userId = parameters.get('userId') || '';
    const token = parameters.get('token') || '';
    const [status, setStatus] = useState<'loading' | 'success' | 'invalid' | 'error'>(userId && token ? 'loading' : 'invalid');
    const started = useRef(false);
    const pending = useRef(false);
    const attempt = useCallback(async () => {
        if (pending.current) return;
        pending.current = true; setStatus('loading');
        try {await confirmEmail(userId, token); setStatus('success');}
        catch (error) {setStatus(normalizeApiError(error).status === 400 ? 'invalid' : 'error');}
        finally {pending.current = false;}
    }, [userId, token]);
    useEffect(() => {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        if (started.current || !userId || !token) return;
        started.current = true;
        void attempt();
    }, [attempt, userId, token]);
    return <RegistrationLayout><Stack spacing={3} sx={{py: 4}}>
        {status === 'loading' && <CircularProgress/>}
        <Typography component="h1" variant="h3">{t(`registration:confirmation_${status}` as never)}</Typography>
        {status === 'success' && <Button component={RouterLink} to="/login" variant="contained">{t('registration:go_to_login')}</Button>}
        {status === 'invalid' && <ResendConfirmation/>}
        {status === 'error' && <Button onClick={attempt}>{t('registration:retry')}</Button>}
    </Stack></RegistrationLayout>;
}
